module.exports = __webpack_public_path__ + "img/Nekesa-Patricia.59b88781.jpeg";